module.exports = __webpack_public_path__ + "media/images/gallery/snr_on-07bd7358aa1c4becb630eb977879a3f5.gif";